import React from "react";
import "./timeline.css";

const Timeline = () => {
    return (
        <div class="container">
            <h1>Education</h1>
            <p class="subtitle">Long time student!</p>

            <div class="timeline">
                <div class="timeline-item">
                    <div class="content">
                        <div class="icon"></div>
                        <span class="date">2005-2007</span>
                        <h2>Play, Nursery, KG</h2>
                        <p>Baby Care</p>
                    </div>
                </div>
                <div class="timeline-item">
                    <div class="content">
                        <div class="icon"></div>
                        <span class="date">2008-2010</span>
                        <h2>Class 1-3</h2>
                        <p>Mohammedpur Government High School</p>
                    </div>
                </div>

                <div class="timeline-item">
                    <div class="content">
                        <div class="icon"></div>
                        <span class="date">2011-2020</span>
                        <h2>Class 4-12</h2>
                        <p>Dhaka Residential Model College</p>
                        <span class="tag">PSC-5.00</span>
                        <span class="tag">JSC-5.00</span>
                        <span class="tag">SSC-5.00</span>
                        <span class="tag">HSC-5.00</span>
                    </div>
                </div>

                <div class="timeline-item">
                    <div class="content">
                        <div class="icon"></div>
                        <span class="date">2022-2026</span>
                        <h2>BSc. in Computer Science</h2>
                        <p>BRAC University</p>
                        <span class="tag">CGPA-3.21</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Timeline;
